import React from "react";
import isEmpty from "lodash/isEmpty";
import { FormProvider } from "react-hook-form";
import { Link } from "react-router";
import { Button, Callout, Form } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { LoginContentWrapper } from "Components";
import { REQUEST_PASSWORD_RESET_ROUTE } from "Constants";
import loginLayoutStyles from "../../../../components/LoginLayout/loginLayout.module.scss";
import EulaLink from "../../components/EulaLink/EulaLink";
import { useLocalLogin } from "../../hooks";
import styles from "./localLogin.module.scss";

type LocalLoginProps = {
  title?: string;
  buttonLabel?: string;
  allowPasswordReset?: boolean;
};

const LocalLogin = ({
  title = "Login",
  buttonLabel = "Log in",
  allowPasswordReset = true,
}: LocalLoginProps): React.JSX.Element => {
  const { isLoginError, errors, methods, onSubmit } = useLocalLogin();

  return (
    <LoginContentWrapper title={title}>
      <FormProvider {...methods}>
        <Form.Form onSubmit={onSubmit}>
          <Form.TextField
            className={getClassName({
              [styles.error]:
                Object.keys(errors).includes("email") || isLoginError,
            })}
            name="email"
            placeholder="Email"
            autoComplete="username"
          />
          <Form.TextField
            className={getClassName({
              [styles.error]:
                Object.keys(errors).includes("password") || isLoginError,
            })}
            placeholder="Password"
            name="password"
            type="password"
            autoComplete="current-password"
          />
          {!isEmpty(errors) ? (
            <Callout
              type="error"
              variant="inline"
              className={styles["invalid-credentials"]}
              title="All fields are required"
            />
          ) : (
            isLoginError && (
              <Callout
                type="error"
                variant="inline"
                className={styles["invalid-credentials"]}
                title="Invalid email or password"
              />
            )
          )}
          {allowPasswordReset && (
            <p className={styles["forgot-password"]}>
              <Link to={`/${REQUEST_PASSWORD_RESET_ROUTE}`}>
                Forgot password?
              </Link>
            </p>
          )}
          <div className={loginLayoutStyles["form-button"]}>
            <Button isFullWidth type="submit" color="primary">
              {buttonLabel}
            </Button>
          </div>
        </Form.Form>
        <EulaLink />
      </FormProvider>
    </LoginContentWrapper>
  );
};

export default LocalLogin;
